import React, { Fragment, useState, useEffect } from 'react';
import { getProducts } from "../../api";
import Navbar from '../../components/Navbar/Navbar'
import Hero4 from '../../components/hero4/hero4';
import Categorys from '../../components/Categorys/Categorys';
import Product2 from '../../components/Product2/Product2';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';


const Shop = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const productsArray = await getProducts();
                setProducts(productsArray);
            } catch (error) {
                console.error('Error fetching products:', error);
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
    };

    const filteredProducts = products.filter(product => {
        if (!selectedCategory) return true;
        return product.category_slug === selectedCategory.slug;
    });

    return (
        <Fragment>  
            <Navbar />
            <Hero4 />
            <Categorys 
                selectedCategory={selectedCategory}
                onCategorySelect={handleCategorySelect}
            />
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <p>Loading products...</p>
                </div>
            ) : (
                <Product2
                    products={filteredProducts}
                />
            )}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default Shop;